export default __webpack_public_path__ + "static/session-card-bg-2-fe0dfbd5a92646f2398849889e6d19fe.png";